import { useEffect, useState } from "react";

const NetworkWarning = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div
      //   style={{
      //     color: "#900",
      //     padding: "10px",
      //     textAlign: "center",
      //     position: "fixed",
      //     top: 0,
      //     width: "100%",
      //     zIndex: 1000,
      //   }}
      className="bg-[#ffe0e0] p-[10px] text-sm text-center fixed z-[1000] top-0 left-0 right-0 font-medium"
    >
      ⚠️ You are currently offline. Make sure your device has an active internet
      connection.
    </div>
  );
};

export default NetworkWarning;
